module.exports = __webpack_public_path__ + "media/images/logo-92c75129695f4c18c960fbd6388286c1.png";